import FileSaver from "file-saver";
import moment from "moment-jalaali";
import jMoment from "components/classes/Jmomen";
import { formatFieldValue, TXT_FORMATS } from "./txtFormatsConfig";

export default class JsonExport {
  constructor(
    dataTables = [],
    allHeaders = [],
    headers = [],
    allFooters = [],
    AllReport = {},
    props = {},

    defaults = null
  ) {
    console.log("dataTablesdataTablesdataTablesdataTables", dataTables);
    console.log("allHeadersallHeadersallHeaders", allHeaders);
    console.log("allFootersallFootersallFooters", allFooters);

    this.defaults = defaults
      ? defaults
      : {
          separator: "-",
          ignoreColumn: [],
          tableName: "exports",
          type: "csv",
          pdfFontSize: 14,
          pdfLeftMargin: 20,
          escape: "false",
          customHeader: "",
          customFooter: "",
          showTitle: "true",
          showFooter: "true",
        };

    this.props = props;
    this.headers = allHeaders;
    this.justShowHeaders = headers;
    this.footerItems = allFooters;
    this.dataTables = dataTables;
  }

  parseString(data) {
    console.log("datadatadata", data);
    const companyCode = localStorage.getItem("CompanyCode");
    console.log("companyCocompanyCodede", companyCode);

    let defaults = this.defaults;
    let _data = data;
    if (defaults.escape === "true") {
      _data = escape(_data);
    }

    return _data.toString().match(/^\d{3,}:\d{2}$/) ? `${_data}` : `${_data}`;
  }

  static getMimeType(type = "csv") {
    switch (type) {
      case "csv":
        return "text/csv";
      case "text":
        return "text/plain";
      case "json":
        return "application/json";
      case "excel":
        return "application/vnd.ms-excel";
      case "doc":
        return "application/msword";
      case "powerpoint":
        return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      case "png":
        return "image/png";
      case "pdf":
        return "application/pdf";
      case "sql":
        return "application/octet-stream";
      default:
        return "text/csv";
    }
  }

  static getExtension(type = "csv") {
    switch (type) {
      case "csv":
        return "csv";
      case "txt1":
        return "txt";
      case "txt2":
        return "txt";
      case "txt3":
        return "txt";
      case "txt4":
        return "txt";
      case "txt5":
        return "txt";
      case "txt6":
        return "txt";
      case "txt7":
        return "txt";
      case "txt8":
        return "txt";
      case "json":
        return "json";
      case "excel":
        return "xls";
      case "doc":
        return "doc";
      case "powerpoint":
        return "ppt";
      case "png":
        return "image/png";
      case "pdf":
        return "pdf";
      case "sql":
        return "sql";
      default:
        return "csv";
    }
  }

  static space(len = 0, _str = " ") {
    let str = "";
    for (let i = 0; i < len; i++) {
      str += _str;
    }
    return str;
  }
  modifyItem(data) {
    if (data.includes(":")) {
      const output = data.split(":").join("");
      return output;
    } else {
      return data;
    }
  }
  // Keep colon for time strings (e.g., "HH:MM"); used where ':' must be present and counted
  modifyItemKeepColon(data) {
    return data;
  }
  modifyItemDependentLeave1(data) {
    const output = data.split(":")[0];
    console.log("dependentDailyLeave1", output);
    return output;
  }
  modifyItemDependentLeave2(data) {
    const output = data.split(":")[1];
    console.log("dependentDailyLeave2", output);
    return output;
  }

  processTxtFormat(format, dataSource, filteredHeaders, thisObject) {
    const defaults = this.defaults;
    let tdData = "";

    // Add custom header
    if (defaults.customHeader) {
      tdData += thisObject.parseString(defaults.customHeader) + "\n";
    }

    // Add date line for txt5 and txt6
    if ((format.name === "txt5" || format.name === "txt6") && dataSource.length > 0) {
      const reportsValues = JSON.parse(localStorage.getItem("reportsValues"));
      if (reportsValues) {
        tdData += `${jMoment(reportsValues?.dateFrom, "YYYY-M-D").format(
          "jYYYY/jMM/jDD"
        )} ${jMoment(reportsValues?.dateTo, "YYYY-M-D").format(
          "jYYYY/jMM/jDD"
        )}\n`;
      }
    }

    // Process data rows (skip headers)
    dataSource.forEach((row, rowIndex) => {
      // Skip last row if needed
      if (format.skipLastRow && rowIndex === dataSource.length - 1) {
        return;
      }

      format.fields.forEach((field, fieldIndex) => {
        if (
          !defaults.ignoreColumn.includes(field.key) &&
          (this.justShowHeaders.length === 0 || this.justShowHeaders.includes(field.key))
        ) {
          let value = row[field.key];
          let formattedValue = formatFieldValue(
            value,
            field,
            this.modifyItem.bind(this),
            this.modifyItemKeepColon.bind(this)
          );

          // Special handling for personnelId with different slice lengths
          if (field.key === "personnelId" && value) {
            if (format.name === "txt3") {
              formattedValue = value.toString().slice(-10).padStart(10, "0");
            } else if (format.name === "txt4") {
              formattedValue = value.toString().slice(-4).padStart(4, "0");
            } else if (format.name === "txt1" || format.name === "txt2") {
              formattedValue = value.toString().slice(-3).padStart(3, "0");
            } else if (format.name === "txt5") {
              formattedValue = value.toString().slice(-5).padStart(5, "0");
            } else if (format.name === "txt6") {
              formattedValue = value.toString().slice(-3).padStart(3, "0");
            }
          }

          const isLast = fieldIndex === format.fields.length - 1;
          const separator = format.separator || (isLast ? "" : defaults.separator || "-");

          tdData += formattedValue + separator;
        }
      });

      tdData += "\n";
    });

    // Add custom footer
    if (defaults.customFooter) {
      tdData += thisObject.parseString(defaults.customFooter) + "\n";
    }

    return tdData;
  }

  exportAs(type = null, filename = "noname") {
    console.log("typetype", type);
    type = type ? type : this.defaults.type;
    let defaults = this.defaults;
    let thisObject = this;
    let tdData = "";
    let modifiedText = "";
    let HeadersSort = [
      { key: "personnelId" },
      { key: "activityDaily" },
      { key: "overtime" },
      { key: "extraUrbanDailyAssignment" },
      { key: "dependentDailyLeave" },
      { key: "sickDailyLeave" },
      { key: "dependentHourlyLeave" },
      { key: "dailyAbsence" },
      { key: "fraction" },
      { key: "outOvertime" },
      { key: "startOvertime" },
      { key: "activity" },
    ];
    let HeadersSort4 = [
      { key: "personnelId" }, // 4 کاراکتر
      { key: "dailyActivity" }, // 2 کاراکتر
      { key: "hourlyActivity" }, // 6 کاراکتر (HH:MM)
      { key: "workShift" }, // 6 کاراکتر (HH:MM)
      { key: "overtime" }, // 6 کاراکتر (HH:MM)
      { key: "fridayWork" }, // 6 کاراکتر (HH:MM)
      { key: "holidayOverTimeOvertime" }, // 6 کاراکتر (HH:MM)
      { key: "delay" }, // 6 کاراکتر (HH:MM)
      { key: "dependentLeave" }, // 6 کاراکتر (HH:MM)
      { key: "sickLeave" }, // 6 کاراکتر (HH:MM)
      { key: "absence" }, // 6 کاراکتر (HH:MM)
      { key: "hourlyAssignment" }, // 6 کاراکتر (HH:MM)
      { key: "dailyAssignment" }, // 6 کاراکتر (HH:MM)
    ];
    let HeadersSort2 = [
      { key: "personnelId" },
      { key: "functionDay" },
      { key: "overtime" },
      { key: "hourlyAbsence" },
      { key: "nightWork" },
      { key: "holidayOvertime" },
      { key: "dependentDailyLeave" },
      { key: "sickDailyLeave" },
      { key: "noSalaryDailyLeave" },
      { key: "dailyAssignment" },
      // { key: "dependentHourlyLeave" },
      { key: "dependentHourlyLeave" },
      { key: "hourlyAssignment" },
    ];
    let sortedHeader2 = HeadersSort2.filter((item) =>
      this.headers.some((obj) => {
        return obj.key === item.key;
      })
    );
    console.log("sortedHeader2", sortedHeader2);
    let sortedHeader = HeadersSort.filter((item) =>
      this.headers.some((obj) => {
        return obj.key === item.key;
      })
    );
    // Force txt4 to follow HeadersSort4 order exactly
    let sortedHeader4 = HeadersSort4;
    console.log("sortedHeader", sortedHeader);
    console.log("sortedHeader4", sortedHeader4);

    switch (type) {
      case "csv":
        console.log("11111111111111111111111111111", this.headers);

        // بررسی وجود customHeader و افزودن آن در صورت وجود
        if (defaults.customHeader) {
          tdData += thisObject.parseString(defaults.customHeader) + "\n";
        }
        console.log("22222222222222222222222222222222222222");

        // بررسی وجود هدرها و نمایش عنوان در صورت فعال بودن
        if (this.headers && defaults.showTitle === "true") {
          this.headers.forEach((header) => {
            if (
              !defaults.ignoreColumn.includes(header.key) &&
              (this.justShowHeaders.length === 0 ||
                this.justShowHeaders.includes(header.key))
            ) {
              tdData +=
                '"' +
                thisObject.parseString(header.title) +
                '"' +
                defaults.separator;
            }
          });
          tdData += "\n";
        }
        this.dataTables.forEach((row) => {
          this.headers.forEach((header) => {
            if (
              !defaults.ignoreColumn.includes(header.key) &&
              (this.justShowHeaders.length === 0 ||
                this.justShowHeaders.includes(header.key))
            ) {
              if (row[header.key]) {
                let cellData = thisObject.parseString(row[header.key]);

                // اعمال تغییرات خاص بر اساس نوع txt
                if (type === "txt1") {
                  // مثال: افزودن فضای خالی برای txt1
                  cellData = cellData.padEnd(header.len || 0, " ");
                }
                // می‌توانید تغییرات خاص برای txt2، txt3 و txt4 را نیز اضافه کنید

                tdData += '"' + cellData + '"' + defaults.separator;
              } else {
                // مدیریت سلول‌های خالی
                let emptyData = "";
                if (header.len) {
                  emptyData = JsonExport.space(header.len, " "); // استفاده از فضای خالی یا صفر بر اساس نیاز
                }
                tdData += '"' + emptyData + '"' + defaults.separator;
              }
            }
          });
          tdData += "\n";
        });

        if (defaults.customFooter) {
          tdData += thisObject.parseString(defaults.customFooter) + "\n";
        }
        break;
      case "txt1":
      case "txt2":
      case "txt3":
      case "txt4":
      case "txt5":
      case "txt6":
      case "txt7":
      case "txt8":
        const format = TXT_FORMATS[type];
        if (!format) {
          console.error(`Unknown txt format: ${type}`);
          tdData = "";
          break;
        }

        // استفاده از dataTables یا footerItems بر اساس فرمت
        const dataSource = format.useFooterItems ? this.footerItems : this.dataTables;

        // فیلتر کردن headers بر اساس ترتیب فیلدهای فرمت
        const filteredHeaders = format.fields
          .map((field) => {
            return this.headers.find((h) => h.key === field.key);
          })
          .filter(Boolean);

        modifiedText = this.processTxtFormat(
          format,
          dataSource,
          filteredHeaders,
          thisObject
        );
        tdData = modifiedText;
        break;
      case "sql":
        tdData = "INSERT INTO `" + defaults.tableName + "`";
        if (!this.headers && defaults.showTitle === "true") {
          tdData += " (";
          this.headers.map((header) => {
            if (
              defaults.ignoreColumn.indexOf(header.key) === -1 &&
              !(
                !this.justShowHeaders &&
                this.justShowHeaders.indexOf(header.key) === -1
              )
            ) {
              tdData += "`" + thisObject.parseString(header.key) + "`,";
            }
          });
          tdData = tdData.substr(0, tdData.length - 1);
          tdData += ")";
        }
        tdData += " VALUES ";

        // Row vs Column
        this.dataTables.map((row) => {
          tdData += "(";
          this.headers.map((header) => {
            if (
              defaults.ignoreColumn.indexOf(header.key) === -1 &&
              !(
                !this.justShowHeaders &&
                this.justShowHeaders.indexOf(header.key) === -1
              )
            ) {
              if (row[header.key]) {
                tdData += '"' + thisObject.parseString(row[header.key]) + '",';
                console.log("tdData1", tdData);
              } else {
                tdData += '""' + defaults.separator;
                console.log("tdData12", tdData);
              }
            }
          });
          tdData = tdData.substr(0, tdData.length - 1);
          tdData += "),";
        });
        tdData = tdData.substr(0, tdData.length - 1);
        tdData += ";";
        console.log("tdData123", tdData);

        break;
      case "json":
        let jsonArray = [];
        let jsonRow;

        this.dataTables.map((row) => {
          jsonRow = {};
          this.headers.map((header) => {
            if (
              defaults.ignoreColumn.indexOf(header.key) === -1 &&
              !(
                !this.justShowHeaders &&
                this.justShowHeaders.indexOf(header.key) === -1
              )
            ) {
              if (row[header.key]) {
                jsonRow[header.key] = thisObject.parseString(row[header.key]);
              } else {
                jsonRow[header.key] = thisObject.parseString("");
              }
            }
          });
          jsonArray.push(jsonRow);
        });
        tdData = JSON.stringify({ data: jsonArray });
        break;
      case "excel":
      case "doc":
      case "powerpoint":
        const CompanyCode = localStorage.getItem("CompanyCode");
        if (CompanyCode === "14806") {
          let excel = "<table>";
          // Header
          if (!app._.isEmpty(this.headers) && defaults.showTitle === "true") {
            excel += "<tr>";

            this.headers.map((header) => {
              if (
                defaults.ignoreColumn.indexOf(header.key) === -1 &&
                !(
                  !app._.isEmpty(this.justShowHeaders) &&
                  this.justShowHeaders.indexOf(header.key) === -1
                )
              ) {
                excel +=
                  "<td>" + thisObject.parseString(header.title) + "</td>";
              }
            });
            excel += "</tr>";
          }
          // Row Vs Column
          let rowCount = 1;

          console.log("thiheaderss", this.headers);
          console.log("this.headersexcel", excel);
          this.dataTables.map((row) => {
            excel += "<tr>";
            let colCount = 0;
            this.headers.map((header) => {
              if (
                defaults.ignoreColumn.indexOf(header.key) === -1 &&
                !(
                  !app._.isEmpty(this.justShowHeaders) &&
                  this.justShowHeaders.indexOf(header.key) === -1
                )
              ) {
                if (row[header.key]) {
                  if (
                    header.valuesType === "string" ||
                    (header.valuesType !== "date" &&
                      header.valuesType !== "datetime")
                  ) {
                    // Handle negative numbers
                    let cellValue = row[header.key];
                    console.log("cellValuecellValue", cellValue);

                    let isNegative =
                      (typeof cellValue === "number" && cellValue < 0) ||
                      (typeof cellValue === "string" &&
                        cellValue.includes("-"));

                    if (
                      typeof cellValue === "string" &&
                      cellValue.includes(":") &&
                      cellValue.includes("-")
                    ) {
                      // For time values with negative sign, moving the negative sign to the front
                      let timeWithoutMinus = cellValue.replace("-", "");
                      excel +=
                        "<td style='mso-number-format:\"@\"'>" +
                        "-" +
                        timeWithoutMinus +
                        "</td>";
                    } else {
                      excel +=
                        "<td" +
                        (isNegative
                          ? " style='mso-number-format:\"#,##0.00\"'"
                          : "") +
                        ">" +
                        thisObject.parseString(cellValue) +
                        "</td>";
                    }
                  } else {
                    if (header.valuesType === "date") {
                      excel +=
                        "<td>" +
                        jMoment(row[header.key], "YYYY-M-D").format(
                          "jYYYY/jMM/jDD"
                        ) +
                        "</td>";
                    }
                    if (header.valuesType === "datetime") {
                      excel +=
                        "<td>" +
                        jMoment(row[header.key], "YYYY-M-D HH:mm:ss").format(
                          "jYYYY/jMM/jDD HH:mm:ss"
                        ) +
                        "</td>";
                    }
                  }
                } else {
                  excel += "<td></td>";
                }
              }
              colCount++;
            });
            rowCount++;
            excel += "</tr>";
          });
          excel += "</table>";

          let excelFile =
            "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:" +
            defaults.type +
            "' xmlns='http://www.w3.org/TR/REC-html40'>";
          excelFile += "<head>";
          if (type === "excel") {
            excelFile += "<!--[if gte mso 9]>";
            excelFile += "<xml>";
            excelFile += "<x:ExcelWorkbook>";
            excelFile += "<x:ExcelWorksheets>";
            excelFile += "<x:ExcelWorksheet>";
            excelFile += "<x:Name>";
            excelFile += "{worksheet}";
            excelFile += "</x:Name>";
            excelFile += "<x:WorksheetOptions>";
            excelFile += "<x:DisplayGridlines/>";
            excelFile += "</x:WorksheetOptions>";
            excelFile += "</x:ExcelWorksheet>";
            excelFile += "</x:ExcelWorksheets>";
            excelFile += "</x:ExcelWorkbook>";
            excelFile += "</xml>";
            excelFile += "<![endif]-->";
          }

          excelFile +=
            '<meta HTTP-EQUIV="Content-Type"  content="application/vnd.ms-word;  charset=utf-8">';

          excelFile += "</head>";
          excelFile += "<body>";
          excelFile += excel;
          excelFile += "</body>";
          excelFile += "</html>";
          tdData = unescape(escape(excelFile));
        } else {
          let excel = "<table>";
          // Header
          if (!app._.isEmpty(this.headers) && defaults.showTitle === "true") {
            excel += "<tr>";

            this.headers.map((header) => {
              if (
                defaults.ignoreColumn.indexOf(header.key) === -1 &&
                !(
                  !app._.isEmpty(this.justShowHeaders) &&
                  this.justShowHeaders.indexOf(header.key) === -1
                )
              ) {
                excel +=
                  "<td>" + thisObject.parseString(header.title) + "</td>";
              }
            });
            excel += "</tr>";
          }
          // Row Vs Column
          let rowCount = 1;

          console.log("thiheaderss", this.headers);
          console.log("this.headersexcel", excel);
          this.dataTables.map((row) => {
            excel += "<tr>";
            let colCount = 0;
            this.headers.map((header) => {
              if (
                defaults.ignoreColumn.indexOf(header.key) === -1 &&
                !(
                  !app._.isEmpty(this.justShowHeaders) &&
                  this.justShowHeaders.indexOf(header.key) === -1
                )
              ) {
                if (row[header.key]) {
                  if (
                    header.valuesType === "string" ||
                    (header.valuesType !== "date" &&
                      header.valuesType !== "datetime")
                  ) {
                    let cellValue = row[header.key];
                    console.log("cellValuecellValue", cellValue);

                    // Check if value matches pattern like 232:32 (large number:number)
                    let isTimeFormat =
                      typeof cellValue === "string" &&
                      /^\d+:\d{2}$/.test(cellValue);

                    let isNegative =
                      (typeof cellValue === "number" && cellValue < 0) ||
                      (typeof cellValue === "string" &&
                        cellValue.includes("-"));

                    if (
                      typeof cellValue === "string" &&
                      cellValue.includes(":") &&
                      cellValue.includes("-")
                    ) {
                      // For time values with negative sign
                      let timeWithoutMinus = cellValue.replace("-", "");
                      excel +=
                        "<td style='mso-number-format:\"@\"'>" +
                        "-" +
                        timeWithoutMinus +
                        "</td>";
                    } else if (isTimeFormat) {
                      // For values like 232:32 - force as text to prevent Excel time conversion
                      excel +=
                        "<td style='mso-number-format:\"@\"'>" +
                        thisObject.parseString(cellValue) +
                        "</td>";
                    } else {
                      excel +=
                        "<td" +
                        (isNegative
                          ? " style='mso-number-format:\"#,##0.00\"'"
                          : "") +
                        ">" +
                        thisObject.parseString(cellValue) +
                        "</td>";
                    }
                  } else {
                    if (header.valuesType === "date") {
                      excel +=
                        "<td>" +
                        jMoment(row[header.key], "YYYY-M-D").format(
                          "jYYYY/jMM/jDD"
                        ) +
                        "</td>";
                    }
                    if (header.valuesType === "datetime") {
                      excel +=
                        "<td>" +
                        jMoment(row[header.key], "YYYY-M-D HH:mm:ss").format(
                          "jYYYY/jMM/jDD HH:mm:ss"
                        ) +
                        "</td>";
                    }
                  }
                } else {
                  excel += "<td></td>";
                }
              }
              colCount++;
            });
            rowCount++;
            excel += "</tr>";
          });
          excel += "</table>";

          let excelFile =
            "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:" +
            defaults.type +
            "' xmlns='http://www.w3.org/TR/REC-html40'>";
          excelFile += "<head>";
          if (type === "excel") {
            excelFile += "<!--[if gte mso 9]>";
            excelFile += "<xml>";
            excelFile += "<x:ExcelWorkbook>";
            excelFile += "<x:ExcelWorksheets>";
            excelFile += "<x:ExcelWorksheet>";
            excelFile += "<x:Name>";
            excelFile += "{worksheet}";
            excelFile += "</x:Name>";
            excelFile += "<x:WorksheetOptions>";
            excelFile += "<x:DisplayGridlines/>";
            excelFile += "</x:WorksheetOptions>";
            excelFile += "</x:ExcelWorksheet>";
            excelFile += "</x:ExcelWorksheets>";
            excelFile += "</x:ExcelWorkbook>";
            excelFile += "</xml>";
            excelFile += "<![endif]-->";
          }

          excelFile +=
            '<meta HTTP-EQUIV="Content-Type"  content="application/vnd.ms-word;  charset=utf-8">';

          excelFile += "</head>";
          excelFile += "<body>";
          excelFile += excel;
          excelFile += "</body>";
          excelFile += "</html>";
          tdData = unescape(escape(excelFile));
        }
    }

    let file = new File(
      modifiedText ? [modifiedText] : [tdData],
      filename + "." + JsonExport.getExtension(type),
      { type: JsonExport.getMimeType(type) + ";charset=utf-8" }
    );
    FileSaver.saveAs(file);
  }

  static removeSp(string) {
    let _string = string ? `${string}` : "";
    if (!_string) return "";
    _string = _string.replace(":", "");
    _string = _string.replace(/:/g, "");
    _string = _string.replace("-", "");
    _string = _string.replace(/-/g, "");
    return _string;
  }

  customExportAs(type = null, filename = "noname") {
    type = type ? type : this.defaults.type;
    let defaults = this.defaults;
    let thisObject = this;
    let tdData = "";

    switch (type) {
      case "csv":
        if (defaults.customHeader && !defaults.customHeader) {
          tdData += thisObject.parseString(defaults.customHeader);
        }
        if (!this.headers && defaults.showTitle === "true") {
          this.props.map((header) => {
            if (
              defaults.ignoreColumn.indexOf(header.dataIndex) === -1 &&
              !(
                !this.justShowHeaders &&
                this.justShowHeaders.indexOf(header.dataIndex) === -1
              )
            ) {
              if (header.reTitle && header.reTitle !== "") {
                tdData +=
                  '"' +
                  thisObject.parseString(header.reTitle) +
                  '"' +
                  defaults.separator;
              } else {
                tdData +=
                  '"' +
                  thisObject.parseString(header.title) +
                  '"' +
                  defaults.separator;
              }
            }
          });
          tdData += "\n";
        }
        this.dataTables.map((row) => {
          this.props.map((header) => {
            if (
              defaults.ignoreColumn.indexOf(header.dataIndex) === -1 &&
              !(
                !this.justShowHeaders &&
                this.justShowHeaders.indexOf(header.dataIndex) === -1
              ) &&
              !(
                defaults.showFooter === "false" &&
                row._props &&
                row._props.type &&
                row._props.type === "footer"
              )
            ) {
              if (row[header.dataIndex]) {
                if (!header.len || header.len === "") {
                  tdData +=
                    '"' +
                    thisObject.parseString(row[header.dataIndex]) +
                    '"' +
                    defaults.separator;
                } else {
                  let string = row[header.dataIndex];
                  if (string.length > header.len) {
                    tdData +=
                      '"' +
                      thisObject.parseString(string.substr(0, header.len)) +
                      '"' +
                      defaults.separator;
                  } else {
                    string += JsonExport.space(header.len - string.length);
                    tdData +=
                      '"' +
                      thisObject.parseString(string) +
                      '"' +
                      defaults.separator;
                  }
                }
              } else {
                let string;
                if (!header.len || header.len === "") {
                  header.len = 0;
                }
                string = JsonExport.space(header.len);
                tdData +=
                  '"' +
                  thisObject.parseString(string) +
                  '"' +
                  defaults.separator;
              }
            }
          });
          tdData += "\n";
        });
        if (defaults.customFooter && !defaults.customFooter) {
          tdData += thisObject.parseString(defaults.customFooter);
        }
        break;
      case "txt1":
      case "txt2":
      case "txt3":
      case "txt4":
      case "txt5":
      case "txt6":
      case "txt7":
      case "txt8":

        if (defaults.customHeader && !defaults.customHeader) {
          tdData += thisObject.parseString(defaults.customHeader);
        }
        if (!this.headers && defaults.showTitle === "true") {
          this.props.map((header) => {
            if (
              defaults.ignoreColumn.indexOf(header.dataIndex) === -1 &&
              !(
                !this.justShowHeaders &&
                this.justShowHeaders.indexOf(header.dataIndex) === -1
              )
            ) {
              if (header.reTitle && header.reTitle !== "") {
                tdData +=
                  '"' +
                  thisObject.parseString(header.reTitle) +
                  '"' +
                  defaults.separator;
              } else {
                tdData +=
                  '"' +
                  thisObject.parseString(header.title) +
                  '"' +
                  defaults.separator;
              }
            }
          });
          tdData += "\n";
        }
        console.log("dataTablesdataTables", dataTables);

        this.dataTables.map((row) => {
          this.props.map((header) => {
            if (
              defaults.ignoreColumn.indexOf(header.dataIndex) === -1 &&
              !(
                !this.justShowHeaders &&
                this.justShowHeaders.indexOf(header.dataIndex) === -1
              ) &&
              !(
                defaults.showFooter === "false" &&
                row._props &&
                row._props.type &&
                row._props.type === "footer"
              )
            ) {
              if (row[header.dataIndex]) {
                let string = "";
                if (header.type && header.type === "def0") {
                  string += JsonExport.removeSp(row[header.dataIndex]);
                } else {
                  string += row[header.dataIndex];
                }
                if (!header.len || header.len === "") {
                  tdData +=
                    "" +
                    thisObject.parseString(string) +
                    "" +
                    defaults.separator;
                } else {
                  if (string.length > header.len) {
                    tdData +=
                      "" +
                      thisObject.parseString(string.substr(0, header.len)) +
                      '"' +
                      defaults.separator;
                  } else {
                    string =
                      JsonExport.space(
                        header.len - string.length,
                        header.type && header.type === "def0" ? "0" : " "
                      ) + string;
                    tdData +=
                      "" +
                      thisObject.parseString(string) +
                      "" +
                      defaults.separator;
                  }
                }
              } else {
                let _string = "";
                if (!header.len || header.len === "") {
                  header.len = 0;
                }
                _string += JsonExport.space(
                  header.len,
                  header.type && header.type === "def0" ? "0" : " "
                );
                tdData +=
                  "" +
                  thisObject.parseString(_string) +
                  "" +
                  defaults.separator;
              }
            }
          });
          tdData += "\n";
        });
        if (defaults.customFooter && !defaults.customFooter) {
          tdData += thisObject.parseString(defaults.customFooter);
        }
        break;
    }

    let file = new File(
      [tdData],
      filename + "." + JsonExport.getExtension(type),
      { type: JsonExport.getMimeType(type) + ";charset=utf-8" }
    );
    FileSaver.saveAs(file);
  }
}
